"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 26" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M7.84615 1H16.1538V1C16.3106 1 16.3819 1.19583 16.2618 1.29659L14.632 2.66351C14.3825 2.87276 14.2588 3.19602 14.3048 3.51836L15.1615 9.51525C15.2066 9.83095 15.3466 10.1255 15.5629 10.3598L16.7478 11.6434C17.2257 12.1612 16.8585 13 16.1538 13V13H7.84615V13C7.14151 13 6.77426 12.1612 7.25221 11.6434L8.4371 10.3598C8.6534 10.1255 8.79338 9.83095 8.83848 9.51525L9.69518 3.51836C9.74123 3.19602 9.61752 2.87276 9.36803 2.66351L7.73824 1.29659C7.61811 1.19583 7.68936 1 7.84615 1V1Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11 13L12 25L13 13", stroke: "black", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 34" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M10.4615 1H21.5385V1C21.7475 1 21.8425 1.26111 21.6823 1.39545L19.5093 3.21802C19.1766 3.49701 19.0117 3.92803 19.0731 4.35781L20.2154 12.3537C20.2755 12.7746 20.4621 13.1673 20.7505 13.4797L22.3304 15.1913C22.9676 15.8816 22.478 17 21.5385 17V17H10.4615V17C9.52201 17 9.03235 15.8816 9.66961 15.1913L11.2495 13.4797C11.5379 13.1673 11.7245 12.7746 11.7846 12.3537L12.9269 4.35781C12.9883 3.92803 12.8234 3.49701 12.4907 3.21802L10.3177 1.39545C10.1575 1.26111 10.2525 1 10.4615 1V1Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M14.6666 17L16 33L17.3333 17", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var PinIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.PinIcon = PinIcon;
//# sourceMappingURL=PinIcon.js.map